

import SortBadge from "../components/sort-badge";

export default {

    components: { SortBadge },
    activated() {
        this.loadData();
    },
    methods: {
        loadData() {
            let t = this;

            axios.get('member/getList', { params: { _order: t.makeSort(t.sort) } }).then(res => {
                if (res.data.status == 1) {
                    t.list.member = res.data.options.items;
                }
            });

        },

    },
    data() {
        return {
            list: {
                member: []
            },
            sort: {
                count_order: 2,
                amount: 0,
                created_at: 0,
            },
        };
    },
};
